/*
$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    console.log(elementTop);
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.fn.isVisibleInScreen = function() {
    var elementTop = jQuery(this).offset().top;
    var viewportTop = jQuery(window.scrollTop);
    var headerHeight = jQuery("header").height;
    if (elementTop <= viewportTop + headerHeight) {
        goToElement(jQuery(this), jQuery("header"));
    }
}
*/

let links = $('a[href^="#"]:not(.has-dropdown)');
let siteHeader = $('.c-site-header');
let urlPage = window.location.href;
let idLink = $('#'+urlPage.split('#')[1]);


if (links.length) {
    $('.o-wrapper-body').on('click', 'a[href^="#"]:not(.has-dropdown)', function () {
        let targetLink = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(targetLink).offset().top - siteHeader.outerHeight() - 10
        });
    });
}

if (idLink.length) {
    $(window).on('load', function () {
        $('html, body').animate({
            scrollTop: idLink.offset().top - siteHeader.outerHeight() - 10
        });
    });
}